import React from 'react'
import cn from 'classnames'

import IconDone from 'client/icons/Done'
import IconShield from 'client/icons/Shield'
import Price from 'client/components/Price'
import useGtmEvent from 'src/hooks/useGtmEvent'

import { usePage } from 'src/hooks/usePage'
import { routes } from 'src/constants/routes'

import styles from './styles.module.css'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'

interface InsuranceSelectorProps {
  currency: string
  description: string
  amount: number
  onClick: (arg0: boolean) => void
  isSelected?: boolean
}

const InsuranceSelector = ({
  currency,
  description,
  amount,
  onClick,
  isSelected = false,
}: InsuranceSelectorProps) => {
  const { notify } = useGtmEvent({ eventName: 'click_refund_protect_detail' })
  const { sendEvent } = useKafkaEvent({ page: routes.detail.page })
  const { pageId } = usePage()

  const handleChange = () => {
    if (onClick) {
      onClick(!isSelected)

      if (pageId === routes.detail.page) {
        notify()
        sendEvent({ section: SECTIONS.INSURANCE_SELECTOR }, { isSelected: !isSelected })
      }
    }
  }

  return (
    <div
      className={cn(styles.insuranceSelectorContainer, {
        [styles.insuranceSelectorSelected]: isSelected,
      })}
    >
      <label className={styles.insuranceSelectorLabel} data-testid="insurance-selector-label">
        <input
          type="checkbox"
          id="insurance"
          data-testid="insurance-selector"
          checked={isSelected}
          onChange={handleChange}
        />
        <span className={styles.insuranceSelectorInputBackground}>
          <span className={styles.insuranceSelectorInput}>
            {isSelected && <IconDone size={12} data-testid="insurance-selection" />}
          </span>
        </span>
        <p>{description}</p>
        <IconShield size={14} />
        <span className={styles.insuranceSelectorPrice}>
          + <Price amount={amount} currency={currency} />
        </span>
      </label>
    </div>
  )
}

export default InsuranceSelector
